// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"568":"7df09a08","5518":"0a0e03cf","8069":"e75f61d4"}[chunkId] + ".chunk.css";
};